import {OmyConst} from "../../OmyConst";
import Omy from "../../Omy";

export default class OSprite extends PIXI.Sprite {
    /**
     * @param {PIXI.Texture} texture - The texture for this sprite
     * @param {String} atlas name if texture in atlas
     */
    constructor(texture, atlas = null) {
        super(((typeof texture === "string") ? Omy.assets.getTexture(texture, atlas) : texture));

        this._onKillEvent = "kill_event";
        this._onReviveEvent = "revive_event";
        this._onDestroyEvent = "destroy_event";
        this._onDownEvent = "down_event";
        this._onUpEvent = "up_event";
        this._onOverEvent = "over_event";
        this._onUpOutSideEvent = "up_out_event";
        this._onOutEvent = "out_event";
        this._onDragStartEvent = "drag_start_event";
        this._onDragStopEvent = "drag_stop_event";
        this._onDragUpdateEvent = "drag_update_event";

        this._atlas = atlas;
        this._saveVisible = true;
        if (Omy.debugMode) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        this._isUpdate = false;
        this.aa_isRegOnDebug = false;
        this.aa_debugTexture = "";
        this.aa_debugAnchorX = -1000;
        this.aa_debugAnchorY = -1000;
        this._inDebug = false;
        /**         * @type {Object}         */
        this.userData = null;
        /**         * @type {Boolean}         */
        this._active = true;
        this.numChildren = 0;
        this._oX = 0;
        this._oY = 0;
        this._oWidth = 0;
        this._oHeight = 0;

        /**         * @type {Array}         */
        this._externalMethodParams = null;
        /**         * @type {Function}         */
        this._externalMethod = null;
        this._isDrag = false;
        this._dragVertical = false;
        this._dragHorizontal = false;
        this._isStartDrag = false;
        this._isCheckInput = false;
        this._soundUp = null;
        this._soundOver = null;

        this.autoReviveChildren = true;
        this.needAutoRevive = false;

        this._textureName = (typeof texture === "string" ? texture : null);

        this._boundsRect = new OmyConst.Rectangle();
        this._localBoundsRect = new OmyConst.Rectangle();

        this._oType = OmyConst.OMY_SPRITE;

        this.aa_isRegOnDebug = false;
        this._inDebug = false;

        this.interactChild = false;
        /** @type {Array.<PIXI.DisplayObject>} */
        this._joinObjects = null;
        this._joinUpdatePause = true;
        this._saveOnDestroy = false;
    }

    /**     * @private     */
    _updateDebug() {
        if (this.cullable) {
            this.aa_isRegOnDebug = !this.aa_isRegOnDebug;
            this.cullable = false;
        }
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
        if (this.aa_debugTexture.length) {
            this.texture = this.aa_debugTexture;
            this.aa_debugTexture = "";
        }
        if (this.aa_debugAnchorX !== -1000) {
            this.anchorX = this.aa_debugAnchorX;
            this.aa_debugAnchorX = -1000;
        }
        if (this.aa_debugAnchorY !== -1000) {
            this.anchorY = this.aa_debugAnchorY;
            this.aa_debugAnchorY = -1000;
        }
    }

    /**     * @public     */
    addChild(child) {
        super.addChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    addChildAt(child, index) {
        super.addChildAt(child, index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChild(child) {
        super.removeChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildAt(index) {
        let child = super.removeChildAt(index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildren(beginIndex, endIndex) {
        let res = super.removeChildren(beginIndex, endIndex);
        this.numChildren = this.children.length;
        return res;
    }

    /**
     * @param {PIXI.DisplayObject} child
     * @returns {boolean}
     */
    contains(child) {
        if (this.children == null) {
            return false;
        }

        return this.children.indexOf(child) >= 0;
    }

    /**     * @public     */
    kill() {
        if (this.destroyed) return this;
        if (this._active) {
            this._active = false;
            if (this._isUpdate)
                Omy.removeUpdater(this.update, this);
            if (this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = false;
                Omy.removeUpdater(this._updateDebug, this);
            }
            if (this.omyTwinned) {
                Omy.remove.tween(this);
                delete this.omyTwinned;
            }

            if (this.children != null) {
                let i = 0;
                let m = this.numChildren;
                let o;
                while (i < this.numChildren && this.numChildren) {
                    o = this.children[i++];
                    if (o.active && o.kill) {
                        o.kill();
                    }
                    if (m !== this.numChildren) {
                        m--;
                        i--;
                    }
                }
            }

            if (this.input)
                this.input = false;
            this._saveVisible = this.visible;
            this.visible = false;
            this.renderable = false;
            this.emit(this._onKillEvent, this);
        }

        return this;
    }

    /**     * @public     */
    revive() {
        if (this.destroyed) return this;
        if (!this._active) {
            this._active = true;
            this.renderable = true;
            if (this._isUpdate)
                Omy.addUpdater(this.update, this);
            if (Omy.debugMode && !this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = true;
                Omy.addUpdater(this._updateDebug, this);
            }

            if (this.children != null) {
                let i = 0;
                let o;
                while (i < this.numChildren) {
                    o = this.children[i++];
                    if ((this.autoReviveChildren || o.needAutoRevive) && !o.active && o.revive) {
                        o.revive();
                    }
                }
            }

            if (this.input)
                this.input = true;
            this.visible = this._saveVisible;
            this.emit(this._onReviveEvent, this);
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        if (this.destroyed) return this;
        options = options || {children: true, texture: false, baseTexture: false};
        if (this.omyTwinned) {
            Omy.remove.tween(this);
            delete this.omyTwinned;
        }
        this.parentGroup && Omy.remove.removeFromLayer(this);
        this.json = null;
        this._atlas = null;
        this._active = false;
        this.userData = null;
        this.numChildren = 0;
        this._boundsRect = null;
        this._localBoundsRect = null;
        this._isDrag = false;
        if (this._listenMouseUp) {
            this._listenMouseUp = false;
            Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        }
        this._isStartDrag = false;
        this._eventData = null;
        this.isUpdate = false;
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }

        if (this._textureName) {
            this._textureName = null;
            Omy.loc.removeUpdate(this._updateLocTexture, this);
        }
        if (this._isLocChange) {
            this._isLocChange = false;
            Omy.loc.removeUpdate(this._updateLoc, this);
        }

        if (this.input) {
            this.input = false;
        }
        this.removeAllListeners(this._onDragStartEvent);
        this.removeAllListeners(this._onDragStopEvent);
        this.removeAllListeners(this._onDragUpdateEvent);
        this.removeAllListeners(this._onDownEvent);
        this.removeAllListeners(this._onOutEvent);
        this.removeAllListeners(this._onOverEvent);
        this.removeAllListeners(this._onUpOutSideEvent);
        this.removeAllListeners(this._onUpEvent);
        this.emit(this._onDestroyEvent, this);
        this.removeAllListeners(this._onDestroyEvent);
        this.removeAllListeners(this._onKillEvent);
        this.removeAllListeners(this._onReviveEvent);

        this._externalMethod = null;
        this._externalMethodParams = null;
        this.renderable = false;
        this.visible = false;
        this._soundUp = null;
        this._soundOver = null;
        if (this._joinObjects) {
            this._joinObjects.length = 0;
            this._joinObjects = null;
            Omy.removeUpdater(this._updateJoinPosition, this);
        }

        super.destroy(options);
        return this;
    }

    /**     * @public     */
    update() {
        if (this._isStartDrag) {
            if (this._eventData.global.x !== this._dragSaveX || this._eventData.global.y !== this._dragSaveY) {
                if (this._dragHorizontal) {
                    this.x = this._oX + this._eventData.global.x - this._dragSaveX;

                    if (this._oX < this._dragXMin) {
                        this.x = this._dragXMin;
                    } else if (this._oX > this._dragXMax) {
                        this.x = this._dragXMax;
                    }
                }
                if (this._dragVertical) {
                    this.y = this._oY + this._eventData.global.y - this._dragSaveY;

                    if (this._oY < this._dragYMin) {
                        this.y = this._dragYMin;
                    } else if (this._oY > this._dragYMax) {
                        this.y = this._dragYMax;
                    }
                }
                this._dragSaveX = this._eventData.global.x;
                this._dragSaveY = this._eventData.global.y;
                this.emit(this._onDragUpdateEvent, this);
                if (!Omy.mouse.isDown) this._upOutSide();
            }
        }
    }

//---------------------------------------
// OVERRIDE
//---------------------------------------

    calculateVertices() {
        try {
            super.calculateVertices();
        } catch (err) {
            let errMessage = "Error at atlas: " + this._atlas + " texture: " + this._textureName;
            console.error(errMessage, "\n", err);
            this.destroy();
        }
    }

//---------------------------------------
// PRIVATE
//---------------------------------------

    _down(event) {
        if (this._isDrag) {
            if (event)
                this._eventData = event.data;
            this._dragSaveX = this._eventData.global.x;
            this._dragSaveY = this._eventData.global.y;
            this._isStartDrag = true;
            this.emit(this._onDragStartEvent, this);
        }

        this.emit(this._onDownEvent, this);
    }

    _over() {
        this.emit(this._onOverEvent, this);
        if (this._soundOver) Omy.sound.play(this._soundOver);
    }

    _out() {
        this.emit(this._onOutEvent, this);
    }

    _upOutSide() {
        this._out();
        this.emit(this._onUpOutSideEvent, this);
    }

    _up() {
        this.emit(this._onUpEvent, this);
        if (this._soundUp) Omy.sound.play(this._soundUp);
        if (this._externalMethod != null)
            this._externalMethod.apply(null, this._externalMethodParams);
    }

    _globalMouseUp() {
        if (this._isDrag && this._isStartDrag) {
            this._eventData = null;
            this._isStartDrag = false;
            this.emit(this._onDragStopEvent, this);
        }
    }

    /**     * @public     */
    onLocalisation(textureName) {
        this._textureName = textureName;
        Omy.loc.addUpdate(this._updateLocTexture, this);
    }

    /**     * @private     */
    _updateLocTexture() {
        this.texture = this._textureName;
    }

    addLocSprite() {
        this._isLocChange = true;
        Omy.loc.addUpdate(this._updateLoc, this);
        this._updateLoc();
    }

    /**     * @private     */
    _updateLoc() {
        for (let key in this.json["loc"]) {
            if (OMY.OMath.inArray(this.json["loc"][key], Omy.language)) {
                this.texture = key;
                break;
            }
        }
        this.emit("loc_texture_update");
    }

    /**     * @public     */
    changeAtlas(atlas, texture = null) {
        this._atlas = atlas;
        if (texture)
            this.texture = texture;
    }

    /**
     * @param {String} aVariableName
     * @param {Object} aValue
     */
    setAll(aVariableName, aValue) {
        let i = 0;
        let o;
        while (i < this.numChildren) {
            o = this.children[i++];
            if (o != null) {
                o[aVariableName] = aValue;
            }
        }
    }

    /**
     * @param {String} aFunctionName
     * @param {Array} aArgs
     */
    callAll(aFunctionName, aArgs = null) {
        if (this.children != null) {
            let i = 0;
            let m = this.numChildren;
            let o;
            while (i < this.numChildren && this.numChildren) {
                o = this.children[i++];
                if (o) {
                    o[aFunctionName].apply(o, aArgs);
                }
                if (m !== this.numChildren) {
                    m--;
                    i--;
                }
            }
        }
    }

    setXY(ax, ay) {
        this._oX = ax;
        this._oY = ay;
        this.position.set(ax, ay);
    }

    setSize(ax, ay) {
        this.width = ax;
        this.height = ay;
    }

    setScale(ax, ay) {
        this.scale.set(ax, ay);
    }

    setAnchor(ax, ay) {
        this.anchor.set(ax, ay);
    }

    setPivot(ax, ay) {
        this.pivot.set(ax, ay);
        this.x = this._oX + ax;
        this.y = this._oY + ay;
    }

    /**
     * @param {Function}eMethod
     * @param {Array}methodParams
     */
    externalMethod(eMethod, methodParams = null) {
        if (!this.input)
            this.input = true;
        this._externalMethod = eMethod;
        methodParams = methodParams || [];
        methodParams.unshift(this);
        this._externalMethodParams = methodParams;
    }

    boundsDragRect(rXMin = NaN, rYMin = NaN, rXMax = NaN, rYMax = NaN) {
        if (!isNaN(rXMin))
            this._dragXMin = rXMin;
        if (!isNaN(rYMin))
            this._dragYMin = rYMin;
        if (!isNaN(rXMax))
            this._dragXMax = rXMax;
        if (!isNaN(rYMax))
            this._dragYMax = rYMax;
    }

    addOver(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOverEvent, func, context, once);
    }

    addOut(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOutEvent, func, context, once);
    }

    addDown(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onDownEvent, func, context, once);
    }

    addUp(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpEvent, func, context, once);
    }

    addUpOutSide(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpOutSideEvent, func, context, once);
    }

    addDragUpdate(func, context, once) {
        this._addNewEvent(this._onDragUpdateEvent, func, context, once);
    }

    addDragStart(func, context, once) {
        this._addNewEvent(this._onDragStartEvent, func, context, once);
    }

    addDragStop(func, context, once) {
        this._addNewEvent(this._onDragStopEvent, func, context, once);
    }

    addKill(func, context, once) {
        this._addNewEvent(this._onKillEvent, func, context, once);
    }

    addRevive(func, context, once) {
        this._addNewEvent(this._onReviveEvent, func, context, once);
    }

    addDestroy(func, context, once) {
        this._addNewEvent(this._onDestroyEvent, func, context, once);
    }

    /**     * @private     */
    _addNewEvent(event, func, context, once = false) {
        if (once)
            this.once(event, func, context);
        else
            this.on(event, func, context);
    }

    removeOver(func, context) {
        this.removeListener(this._onOverEvent, func, context);
    }

    removeOut(func, context) {
        this.removeListener(this._onOutEvent, func, context);
    }

    removeDown(func, context) {
        this.removeListener(this._onDownEvent, func, context);
    }

    removeUp(func, context) {
        this.removeListener(this._onUpEvent, func, context);
    }

    removeUpOutSide(func, context) {
        this.removeListener(this._onUpOutSideEvent, func, context);
    }

    removeDragUpdate(func, context) {
        this.removeListener(this._onDragUpdateEvent, func, context);
    }

    removeDragStart(func, context) {
        this.removeListener(this._onDragStartEvent, func, context);
    }

    removeDragStop(func, context) {
        this.removeListener(this._onDragStopEvent, func, context);
    }

    removeKill(func, context) {
        this.removeListener(this._onKillEvent, func, context);
    }

    removeRevive(func, context) {
        this.removeListener(this._onReviveEvent, func, context);
    }

    removDestroy(func, context) {
        this.removeDestroy(func, context);
    }

    removeDestroy(func, context) {
        this.removeListener(this._onDestroyEvent, func, context);
    }

    /**
     * add object to join update position
     * @param {PIXI.DisplayObject} object
     */
    regJoinObjects(object) {
        if (!object) return;
        if (this._joinObjects == null) {
            this._joinObjects = [];
            this.joinUpdatePause = false;
        }
        object.joinX = object.json["joinX"] || 0;
        object.joinY = object.json["joinY"] || 0;
        this._joinObjects.push(object);
    }

    /**     * @private     */
    _updateJoinPosition() {
        if (!this._active) return;
        let i = 0;
        let o;
        while (i < this._joinObjects.length) {
            o = this._joinObjects[i++];
            if (o.active && ((o.x !== this.x + o.joinX) || (o.y !== this.y + o.joinY))) {
                o.x = this.x + o.joinX;
                o.y = this.y + o.joinY;
            }
        }
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------

    set isUpdate(value) {
        if (!this._isUpdate && value) {
            Omy.addUpdater(this.update, this);
        } else if (this._isUpdate && !value) {
            Omy.removeUpdater(this.update, this);
        }
        this._isUpdate = value;
    }

    get isUpdate() {
        return this._isUpdate;
    }

    get active() {
        return this._active;
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this.scale.y = value;
    }

    get pivotX() {
        return this.pivot.x;
    }

    set pivotX(value) {
        this.pivot.x = value;
    }

    get pivotY() {
        return this.pivot.y;
    }

    set pivotY(value) {
        this.pivot.y = value;
    }

    get anchorX() {
        return this.anchor.x;
    }

    set anchorX(value) {
        this.anchor.x = value;
    }

    get anchorY() {
        return this.anchor.y;
    }

    set anchorY(value) {
        this.anchor.y = value;
    }

    get localLeft() {
        return this._localBoundsRect.left;
    }

    get localRight() {
        return this._localBoundsRect.right;
    }

    get localTop() {
        return this._localBoundsRect.top;
    }

    get localBottom() {
        return this._localBoundsRect.bottom;
    }

    get localWidth() {
        return this._localBoundsRect.width;
    }

    get localHeight() {
        return this._localBoundsRect.height;
    }

    get globalLeft() {
        return this.getGlobalPosition().x + this.localLeft;
    }

    get globalTop() {
        return this.getGlobalPosition().y + this.localTop;
    }

    get worldX() {
        return this.getGlobalPosition().x;
    }

    get worldY() {
        return this.getGlobalPosition().y;
    }

    get x() {
        this._oX = super.x;
        return this._oX;
    }

    set x(value) {
        super.x = this._oX = value;
    }

    get y() {
        this._oY = super.y;
        return this._oY;
    }

    set y(value) {
        super.y = this._oY = value;
    }

    get height() {
        this._oHeight = super.height;
        return this._oHeight;
    }

    set height(value) {
        return super.height = this._oHeight = value;
    }

    get width() {
        this._oWidth = super.width;
        return this._oWidth;
    }

    set width(value) {
        return super.width = this._oWidth = value;
    }

    get oType() {
        return this._oType;
    }

    get input() {
        return this._isCheckInput;
    }

    set input(value) {
        if (this.input) {
            this.interactive = value;
        } else if (value) {
            this._isCheckInput = true;
            this.interactive = true;
            this.on("pointerdown", this._down, this);
            this.on("pointerup", this._up, this);
            this.on("pointerupoutside", this._upOutSide, this);
            this.on("pointerover", this._over, this);
            this.on("pointerout", this._out, this);
        }
    }

    set drag(value) {
        if (!this.input)
            this.input = true;

        if (!this._isUpdate) this.isUpdate = true;

        this._isDrag = value;
        this._listenMouseUp = value;
        (this._listenMouseUp) ? Omy.mouse.addUpHandler(this._globalMouseUp, this) : Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        this._dragVertical = true;
        this._dragHorizontal = true;
    }

    set allowHorizontalDrag(value) {
        this._dragHorizontal = value;
    }

    set allowVerticalDrag(value) {
        this._dragVertical = value;
    }

    set textureName(value) {
        this._textureName = value;
    }

    get textureName() {
        return this._textureName;
    }

    set texture(value) {
        if (typeof value === "string") {
            this._textureName = value;
            super.texture = Omy.assets.getTexture(value, this._atlas);
        } else {
            super.texture = value;
        }
    }

    get texture() {
        return this._texture;
    }

    set interactChild(value) {
        this.interactiveChildren = value;
    }

    get atlas() {
        return this._atlas;
    }

    set soundUp(value) {
        this._soundUp = value;
    }

    set soundOver(value) {
        this._soundOver = value;
    }

    set joinUpdatePause(value) {
        if (this._joinUpdatePause !== value)
            if (value) Omy.removeUpdater(this._updateJoinPosition, this);
            else Omy.addUpdater(this._updateJoinPosition, this);
        this._joinUpdatePause = value;
    }

    get saveOnDestroy() {
        return this._saveOnDestroy;
    }

    set saveOnDestroy(value) {
        this._saveOnDestroy = value;
    }
}
